import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { useToggle, useFieldValue } from 'Shared/utils/hooks';
import { getGoalsByComplete, getGoalById } from 'Shared/selectors/Goals.selectors';
import { fetchGoals } from 'Shared/actions/Goals.actions';
import ColorConstants from 'Wpds/colors/ColorConstants';

//Components
import SubGoalSingleValue from 'Shared/components/Goals/AddSubGoal/SubGoalField/SubGoalSingleValue/SubGoalSingleValue';
import SubGoalFieldOption from 'Shared/components/Goals/AddSubGoal/SubGoalField/SubGoalFieldOption/SubGoalFieldOption';
import FormSelect from 'Shared/components/FormComponents/FormSelect';
import { Field } from 'react-final-form';

import './ParentGoalField.scss';

const styles = {
  container: base => ({
    ...base,
    width: '100%',
    maxWidth: '300px',
    display: 'flex',
  }),
  control: base => ({ ...base, width: '100%' }),
  indicatorsContainer: base => ({ ...base, padding: '0 0.5rem', color: ColorConstants.gray[500] }),
};

function SubGoalField() {
  const dispatch = useDispatch();

  const [isFetching, toggleIsFetching] = useToggle(false);
  useEffect(() => {
    async function fetchData() {
      toggleIsFetching();
      await dispatch(fetchGoals({ context: 'team' }));
      toggleIsFetching();
    }

    fetchData();
  }, []);

  const goals = useSelector(state => getGoalsByComplete(state, { complete: false }).valueSeq().toJS());

  // If the form was initialized with a parentId value pointing to a completed goal then ensure that
  // the goal is in the list of select options
  const parentId = useFieldValue('parentId');
  const parentGoal = useSelector(state => getGoalById(state, { id: parentId })?.toJS());
  if (parentGoal && !goals.find(({ id }) => id === parentGoal.id)) {
    goals.push(parentGoal);
  }

  const options = goals.map(({ name, id, slug, assigneeId, icon, parentId, workspaceSlug, privacySetting }) => ({
    label: name,
    value: id,
    slug,
    assigneeId,
    icon,
    parentId,
    workspaceSlug,
    privacySetting,
  }));

  return (
    <div className="ParentGoalField">
      <Field name="parentId">
        {({ input: { value, onChange } }) => {
          return (
            <>
              <FormSelect
                isClearable
                id="parent-goal-select"
                isLoading={isFetching}
                options={options}
                styles={styles}
                components={{
                  Option: SubGoalFieldOption,
                  SingleValue: SubGoalSingleValue,
                  IndicatorSeparator: null,
                }}
                placeholder="Choose..."
                value={value}
                onChange={onChange}
              />
            </>
          );
        }}
      </Field>
    </div>
  );
}

export default SubGoalField;
